import React from "react";
import ProfileInfo from "../components/ProfileInfo";
import ProfileSettings from "../components/ProfileSettings";

const UserProfilePage = () => {
  return (
    <div className="user-profile-page">
      <div className="title">My Profile</div>
      <div className="sub-title">View and modify your profile information as needed.</div>
      <div className="row">
        <ProfileInfo />
        <ProfileSettings />
      </div>
    </div>
  );
};

export default UserProfilePage;
